/**
 * Geographic scope of the empowerment programme.
 *
 * The programme serves Lapai Local Government only — permanently, as the
 * scholarship does. State and LGA are therefore constants set server-side and
 * never accepted from the client; ward is the only geographic value an
 * applicant supplies.
 *
 * Decision D5.
 */

export const STATE = "Niger" as const;
export const LGA = "Lapai" as const;

/** The ten wards of Lapai LGA. */
export const LAPAI_WARDS = [
  "Gabas/Kudu",
  "Arewa/Yamma",
  "Duma/Zago",
  "Takuti/Shaku",
  "Birnin Maza/Tashibo",
  "Gulu/Anguwa",
  "Evuti/Kpada",
  "Ebbo/Gbacinku",
  "Muye/Egba",
  "Gupa/Abugi",
] as const;

export type LapaiWard = (typeof LAPAI_WARDS)[number];

/**
 * Authoritative membership check. Used server-side at submit — the dropdown is
 * a convenience, this is the control.
 */
export function isLapaiWard(value: string | null | undefined): value is LapaiWard {
  if (!value) return false;
  return (LAPAI_WARDS as readonly string[]).includes(value);
}

/**
 * The wards open for a given cycle. `null` or an empty list means all ten;
 * anything else is filtered against the authoritative list so a stale or
 * mistyped configuration value cannot introduce a ward that does not exist.
 */
export function wardsForCycle(allowedWards: string[] | null | undefined): LapaiWard[] {
  if (!allowedWards || allowedWards.length === 0) return [...LAPAI_WARDS];
  return LAPAI_WARDS.filter((ward) => allowedWards.includes(ward));
}
